import { useEffect, useState } from 'react';
import '../styles/container.css';

function Contact() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('success') === '1') {
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        const url = new URL(window.location);
        url.searchParams.delete('success');
        window.history.replaceState({}, '', url);
      }, 5000);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <main className="flex-grow py-12 px-4">
        <div className="container max-w-4xl mx-auto bg-white p-10 shadow-xl rounded-xl text-gray-800 leading-relaxed text-[21px]">
          <h1 className="text-4xl font-bold mb-2 border-l-4 border-blue-600 pl-4">
            Contact Us
          </h1>

          <p className="text-sm text-gray-500 mb-10 text-right">We’re here to help</p>
          <p className="mb-8">
            Iword Hosting delivers scalable infrastructure in 32 global regions with 1-click deployment of 12 operating systems, 100+ applications, and customizable specs. Whether you need cPanel & WHM, or OpenLiteSpeed WordPress on Ubuntu 24.04, we’ve got you covered. Looking for something special? Just let us know — we support developers, businesses, and institutions with tailored hosting stacks built for performance.
          </p>

          {showPopup && (
            <div className="mt-6 p-4 bg-green-100 border border-green-400 text-green-800 rounded-md text-center transition-all">
              ✅ Thank you! Your message has been sent successfully.
            </div>
          )}

          <form
            action="https://i-word.net/api/contact.php"
            method="POST"
            className="space-y-6"
          >
            <div>
              <label className="block font-semibold mb-1">Full Name</label>
              <input type="text" name="full_name" required className="w-full border border-gray-300 p-3 rounded-md" />
            </div>

            <div>
              <label className="block font-semibold mb-1">Email</label>
              <input type="email" name="email" required className="w-full border border-gray-300 p-3 rounded-md" />
            </div>

            <div>
              <label className="block font-semibold mb-1">Telephone (Optional)</label>
              <input type="tel" name="telephone" className="w-full border border-gray-300 p-3 rounded-md" />
            </div>

            <div>
              <label className="block font-semibold mb-1">Operating System Requests</label>
              <select name="operating_system" className="w-full border border-gray-300 p-3 rounded-md">
                <option value="">-- Select Operating System --</option>
                <option value="Ubuntu 24.04">Ubuntu 24.04</option>
                <option value="Ubuntu 22.04">Ubuntu 22.04</option>
                <option value="Debian 12">Debian 12</option>
                <option value="Debian 11">Debian 11</option>
                <option value="Rocky Linux 10">Rocky Linux 10</option>
                <option value="Rocky Linux 9">Rocky Linux 9</option>
                <option value="Rocky Linux 8">Rocky Linux 8</option>
                <option value="AlmaLinux 9">AlmaLinux 9</option>
                <option value="AlmaLinux 8">AlmaLinux 8</option>
                <option value="FreeBSD 14">FreeBSD 14</option>
                <option value="Fedora 40">Fedora 40</option>
                <option value="Arch Linux">Arch Linux</option>
                <option value="openSUSE Leap 15.5">openSUSE Leap 15.5</option>
              </select>
            </div>

            <div>
              <label className="block font-semibold mb-1">Application Requests</label>
              <select name="application_requests" className="w-full border border-gray-300 p-3 rounded-md">
                <option value="">-- Select Application --</option>
                <option value="WordPress">WordPress</option>
                <option value="OpenLiteSpeed">OpenLiteSpeed</option>
                <option value="CyberPanel">CyberPanel</option>
                <option value="Easypanel">EasyPanel</option>
                <option value="Plesk">Plesk</option>
                <option value="Webmin">Webmin</option>
                <option value="Docker">Docker</option>
                <option value="Laravel">Laravel</option>
                <option value="Magento">Magento</option>
                <option value="Drupal">Drupal</option>
                <option value="Joomla">Joomla</option>
                <option value="Ghost">Ghost</option>
                <option value="Nextcloud">Nextcloud</option>
                <option value="Matomo">Matomo</option>
                <option value="Mailcow">Mailcow</option>
                <option value="OpenVPN">OpenVPN</option>
                <option value="None / Custom Setup">None / Custom Setup</option>
              </select>
            </div>

            <div>
              <label className="block font-semibold mb-1">Type of Business</label>
              <input type="text" name="business_type" className="w-full border border-gray-300 p-3 rounded-md" />
            </div>

            <div>
              <label className="block font-semibold mb-1">Other Requests</label>
              <textarea name="additional_requests" rows="5" placeholder="Type here any request you may have" className="w-full border border-gray-300 p-3 rounded-md"></textarea>
            </div>

            <div>
              <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-full transition duration-200">
                Send Message
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default Contact;
